import styled from 'styled-components';

export const PreviewCtaWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 0.5rem;
`;

export const Page = styled.div`
    max-width: 720px;
    margin: 0 auto;
    padding: 2rem 1rem 4rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export const Title = styled.h1`
    font-size: 1.5rem;
    font-weight: 700;
`;

export const Notice = styled.p`
    background: ${({ theme }) => theme.colors['warn-shopping']};
    border: 1px solid ${({ theme }) => theme.colors['supernova-500']};
    color: ${({ theme }) => theme.colors['text-warn']};
    border-radius: 0.75rem;
    padding: 1rem;
    line-height: 1.4;
`;

export const PrimaryButton = styled.button`
    align-self: stretch;
    padding: 0.9rem 1.25rem;
    border: none;
    border-radius: 0.75rem;
    background: ${({ theme }) => theme.colors['supernova-500']};
    color: ${({ theme }) => theme.colors['text-warn']};
    font-weight: 700;
    font-size: 1rem;
    cursor: pointer;

    &:hover {
        background: ${({ theme }) => theme.colors['supernova-600']};
    }
`;

export const SecondaryButton = styled.button`
    align-self: stretch;
    padding: 0.9rem 1.25rem;
    border: 1px solid ${({ theme }) => theme.colors['supernova-700']};
    border-radius: 0.75rem;
    background: transparent;
    color: ${({ theme }) => theme.colors['supernova-700']};
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;

    &:hover {
        background: ${({ theme }) => theme.colors['supernova-100']};
    }
`;
